<!-- Translated: yes -->
<template>
  <div :class="'field field--' + type" @click="$emit('click')">
    <!-- <span class="prefix">
      <icon name="calendar" :scale="1"></icon>
    </span> -->
    <input type="text" name="" :value="text" @keyup.enter="changeText" :placeholder="placeholder" @blur="changeText">
    <span class="suffix">
      <icon name="Search-white" :scale="1.5"></icon>
    </span>
  </div>

</template>

<script>
// import {
//   formatAccomodationsFilterDate,
// } from '@/lib';

export default {
  props: {
    value: {},
    placeholder: {},
    keyenter: {
      type: Function,
    },
    type: {
      default: 'normal',
    },
  },
  data() {
    return {
      text: this.value,
    };
  },
  methods: {
    changeText(event) {
      this.text = event.target.value;
      this.$emit('change', this.text);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

border = solid 2px light-blue-grey

affix()
  width 45px
  height 38px
  display flex
  align-items center
  justify-content center
  .field--higher &
    height 50px
    width 55px

.field
  display flex
  border border
  border-radius 4px
  background white
  overflow hidden
  align-items center
  cursor pointer
  transition-ease()
  &:hover
    &, .suffix
      border-color blue-gray

input[type="text"]
  border none
  .field--higher &
    font-size 16px

.prefix
  affix()
  background deep-sea-blue
  color white

.suffix
  affix()
  transition-ease()
  background deep-sea-blue
  &:hover
    background: dark-blue

.value
  font-size 14px
  flex auto
  padding space-1

</style>



// WEBPACK FOOTER //
// TextInput.vue?227ff579